/**
 * NoPasswords WebAuthn Client Library
 *
 * A TypeScript library for WebAuthn/FIDO2 passwordless authentication
 *
 * @packageDocumentation
 */
// Secure Remote Password (SRP) Exports
export { SRPClient } from './srp/client';
export { getGroup, computeK, bigIntToBytes, bytesToBigInt, padBytes } from './srp/groups';
